module.exports = __webpack_public_path__ + "static/media/WhiteBackground.3b0a2377.jpg";